module.exports = __webpack_public_path__ + "img/video_thumbnail.d5c6cb58.png";